<template>
  <div class="product-common">
    <b-modal
      id="md-change-status-product-excel"
      hide-footer
      title="Đổi trạng thái các sản phẩm"
      no-close-on-backdrop
      size="xl"
    >
      <div class="mt-4">
        <div class="mb-4">
          <b-row>
            <b-col>
              <div class="form-group">
                <span>
                  <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel
                  đúng format, hoặc có thể tải ở
                  <a :href="urlExcel">đây</a>
                </span>
              </div>
            </b-col>
          </b-row>
          <!-- Nhập file -->
          <b-row>
            <b-col cols="12">
              <span> <b>Bước 2:</b> Nhập sản phẩm và tải lên </span>
              <UploadFileMulter
                v-on:send-file="getDataFromExcel"
                v-on:clear-file="clearFileExcel"
                :cmdUrl="'product/import-status-excel'"
              />
              <span v-if="fileName"
                >Tên file: <b>{{ fileName }}</b>
              </span>
            </b-col>
          </b-row>
        </div>
        <div class="flex-column">
          <b-row class="my-2">
            <b-col cols="4">
              <b-form-group
                label-cols-sm="4"
                label-cols-lg="4"
                label="Chọn trạng thái"
                label-class="font-weight-bold"
                class="mb-0 flex-column align-items-center"
              >
                <treeselect
                  :options="optionStatus"
                  :multiple="false"
                  placeholder="Nhập trạng thái:"
                  noResultsText="Không có kết quả"
                  :match-keys="['label', 'custom']"
                  v-model="statusParent"
                  openDirection="bottom"
                  :clearable="false"
                  @select="onSelectStatus"
                >
                  <label
                    slot="option-label"
                    slot-scope="{ node, labelClassName }"
                    :class="labelClassName"
                  >
                    <span :title="node.label"> {{ node.label }}</span>
                  </label>
                </treeselect>
              </b-form-group>
            </b-col>
          </b-row>

          <b-table
            class="table-common mt-4"
            hover
            bordered
            :items="items"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template #cell(statusValidate)="data">
              <div v-if="!data.item.onLoading" class="d-table-row">
                <div class="d-table-cell align-middle" style="width: 10%">
                  <i
                    v-b-tooltip.hover
                    :title="htmlGetStatusValidate(data.item, 'title')"
                    :class="htmlGetStatusValidate(data.item, 'class')"
                  ></i>
                </div>
                <div
                  class="d-table-cell align-middle pb-1 pl-2"
                  style="width: 90%"
                >
                  {{ data.item.statusValidateName }}
                </div>
              </div>
              <div v-else>
                <b-spinner
                  small
                  label="Small Spinner"
                  variant="primary"
                  class="mr-1"
                ></b-spinner>
                <span class="text-primary">Đang xử lí...</span>
              </div>
            </template>
            <template #cell(productName)="data">
              <span>
                {{ data.item.productName }}
              </span>
            </template>
            <template #cell(status)="data">
              <b-form-group class="mb-0 d-flex align-items-center">
                <div class="d-table-row">
                  <div class="d-table-cell align-middle" style="width: 30%">
                    <label class="font-weight-bold pt-1">
                      {{ data.item.statusName }}
                    </label>
                  </div>
                  <div class="d-table-cell align-middle" style="width: 10%">
                    <i
                      class="fa fa-arrow-right text-primary"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div
                    class="d-table-cell align-middle mb-0"
                    style="width: 65%"
                  >
                    <treeselect
                      :options="optionStatus"
                      :multiple="false"
                      placeholder="Chọn trạng thái"
                      noResultsText="Không có kết quả"
                      :match-keys="['label', 'custom']"
                      v-model="data.item.toStatus"
                      openDirection="bottom"
                      :clearable="false"
                      @select="onChangeStatus(data.item, $event)"
                      class="m-2"
                    >
                      <label
                        slot="option-label"
                        slot-scope="{ node, labelClassName }"
                        :class="labelClassName"
                      >
                        <span :title="node.label"> {{ node.label }}</span>
                      </label>
                    </treeselect>
                  </div>
                </div>
              </b-form-group>
            </template>
            <template #cell(actions)="row">
              <v-icon
                small
                class="text-danger"
                @click="onRemovedItem(row.item.id)"
                v-b-tooltip
                >mdi-delete</v-icon
              >
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            v-show="rows > perPage"
            aria-controls="my-table"
          ></b-pagination>
          <vcl-table
            v-if="onLoadingList"
            :speed="5"
            :animate="true"
            :columns="10"
            class="mb-4"
          ></vcl-table>
        </div>
      </div>
      <b-overlay
        :show="onLoadingList || isBusy"
        rounded
        opacity="0.6"
        class="d-inline-block mr-3"
      >
        <template #overlay>
          <div class="d-flex align-items-center">
            <b-spinner variant="light" small type="grow"></b-spinner>
          </div>
        </template>
        <b-button variant="primary" size="sm" @click="onSaveProductStatus">
          <strong>Cập nhật</strong>
        </b-button>
      </b-overlay>

      <b-button
        style="width: 80px"
        variant="secondary"
        size="sm"
        @click="hideModalChangeStatus()"
      >
        <strong>Hủy</strong>
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import {
  cloneDeep,
  makeToastFaile,
  makeToastSuccess,
  wait,
} from '@/utils/common';
import { VclTable } from 'vue-content-loading';
import { EventBus } from '@/core/services/event-bus';
import { PRODUCT_STATUS } from '@/utils/enum';
import { PRODUCT_STATUS_NAME } from '@/utils/enum-name';
import UploadFileMulter from '@/view/modules/upload/UploadFileMulter';
import { TIME_TRIGGER, URL_IMPORT_PRODUCT_STATUS } from '@/utils/constants';
import { showConfirmDialog } from '@/utils/sweet-alert2';

const STATUS_VALIDATE = {
  INVALID: 0,
  VALID: 1,
};
const thStyleCommon = {
  textAlign: 'center',
  fontWeight: 600,
  color: '#181c32',
  width: '5%',
};

export default {
  components: {
    Treeselect,
    VclTable,
    UploadFileMulter,
  },
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'ID sản phẩm',
          thStyle: {
            ...thStyleCommon,
            width: '10%',
          },
          formatter: (value) => {
            return value;
          },
          tdClass: 'align-middle',
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
          thStyle: {
            ...thStyleCommon,
            width: '30%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'status',
          label: 'Đổi trạng thái',
          thStyle: {
            ...thStyleCommon,
            width: '40%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'statusValidate',
          label: 'Kiểm tra',
          thStyle: {
            ...thStyleCommon,
            width: '15%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'actions',
          label: '',
          tdClass: 'align-middle',
        },
      ],
      items: [],
      optionStatus: [],
      onLoadingList: false,
      isBusy: false,
      statusParent: null,
      currentPage: 1,
      perPage: 10,
      urlExcel: URL_IMPORT_PRODUCT_STATUS,
      fileName: '',
      file: null,
      isCancelled: false,
    };
  },
  created() {
    this.initConstants();
  },
  mounted() {
    EventBus.$on('popup-product-status-excel', this.popupProductCommon);
  },
  beforeDestroy() {
    EventBus.$off('popup-product-status-excel', this.popupProductCommon);
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  methods: {
    showConfirmDialog,

    transformToTreeselectOptions(items) {
      return items.reduce((result, element) => {
        if (element.value !== null) {
          result.push({
            id: Number(element.value),
            label: element.text,
            custom: element.text.toLowerCase().replace(/\s+/g, ''),
            customLabel: element.text,
            originalValue: element.value,
          });
        }
        return result;
      }, []);
    },

    initConstants() {
      const statusOptions = [
        { value: PRODUCT_STATUS.NEW, text: PRODUCT_STATUS_NAME[PRODUCT_STATUS.NEW] },
        { value: PRODUCT_STATUS.SELLING, text: PRODUCT_STATUS_NAME[PRODUCT_STATUS.SELLING] },
        { value: PRODUCT_STATUS.STOP_SELLING, text: PRODUCT_STATUS_NAME[PRODUCT_STATUS.STOP_SELLING] },
        { value: PRODUCT_STATUS.OUT_OF_STOCK, text: PRODUCT_STATUS_NAME[PRODUCT_STATUS.OUT_OF_STOCK] },
      ];

      this.optionStatus = this.transformToTreeselectOptions(statusOptions);
    },

    htmlGetStatusValidate(item, type) {
      let name = '';
      switch (item.statusValidate) {
        case STATUS_VALIDATE.VALID: {
          name =
            type === 'class' 
              ? 'fas fa-check-circle text-success' 
              : item.statusValidateName || 'Hợp lệ';
          break;
        }
        default: {
          name =
            type === 'class'
              ? 'fas fa-times-circle text-danger'
              : item.statusValidateName || 'Lỗi';
          break;
        }
      }
      return name;
    },

    onSelectStatus(node) {
      const statusChanged = node.id;

      this.items.forEach((item) => {
        this.updateItemStatus({
          item,
          statusNode: node,
          statusId: statusChanged,
        });
      });
    },

    updateItemStatus({ item, statusNode }) {
      item.toStatus = statusNode.id;
      item.toStatusName = statusNode.label;
      // Hiển thị hợp lệ khi chọn trạng thái
      item.statusValidate = STATUS_VALIDATE.VALID;
      item.statusValidateName = 'Hợp lệ';
    },

    onChangeStatus(itemSelected, event) {
      const index = this.items.findIndex(
        (item) => item.id === itemSelected.id,
      );
      if (index > -1) {
        this.items[index].toStatus = event.id;
        this.items[index].toStatusName = event.label;
        // Hiển thị hợp lệ khi chọn trạng thái
        this.items[index].statusValidate = STATUS_VALIDATE.VALID;
        this.items[index].statusValidateName = 'Hợp lệ';
      }
    },

    hideModalChangeStatus() {
      if (this.items.length) {
        const description = `Bạn có chắc chắn muốn hủy cập nhật trạng thái sản phẩm?`;
        this.showConfirmDialog(`Hủy cập nhật!`, description)
          .then(async () => {
            if (!this.isBusy) {
              this.items = [];
            } else {
              this.isCancelled = true;
            }
            this.$bvModal.hide('md-change-status-product-excel');
          })
          .catch(() => {
            this.isCancelled = false;
          });
      } else {
        this.$bvModal.hide('md-change-status-product-excel');
        this.items = [];
      }
    },

    onRemovedItem(itemRemoveId) {
      if (this.isBusy) {
        return makeToastFaile('Không thể xóa khi đang cập nhật!');
      }
      const index = this.items.findIndex((item) => item.id === itemRemoveId);
      if (index > -1) {
        this.items.splice(index, 1);
      }
    },

    onSaveProductStatus: async function () {
      const items = cloneDeep(this.items);

      if (items.length > 100) {
        return makeToastFaile(
          `Vui lòng không cập nhật quá 100 sản phẩm cùng lúc!`,
        );
      }
      if (!this.isBusy) {
        this.isBusy = true;
        const dataMessages = {
          success: [],
          failed: [],
        };
        // let setTimeoutLasted = false;
        for (const item of items) {
          if (this.isCancelled) {
            break;
          }
          const index = this.items.findIndex((e) => e.id === item.id);

          if (index > -1) {
            this.items[index].onLoading = true;
            const itemPage = Math.ceil((index + 1) / this.perPage);
            if (itemPage !== this.currentPage) {
              this.currentPage = itemPage;
            }
          }

          const param = {
            id: item.id,
            status: item.toStatus,
          };

          const [status, message] = await ApiService.put(
            `/product/update-status`,
            param,
          )
            .then((response) => {
              const { status, message } = response.data;
              return [status, message];
            })
            .catch((err) => {
              this.$nprogress.done();
              if (!err.response) {
                return [0, 'Lỗi mạng'];
              } else {
                const message = err.response.data.message;
                return [0, message];
              }
            });
          await wait(2000);
          if (index > -1) {
            this.items[index].onLoading = false;
            if (status) {
              dataMessages.success.push(item);
              this.items[index].statusValidate = STATUS_VALIDATE.VALID;
              this.items[index].statusValidateName = 'Cập nhật thành công';
            } else {
              this.items[index].statusValidate = STATUS_VALIDATE.INVALID;
              this.items[index].statusValidateName = message || 'Lỗi';
            }
          }
        }
        this.isBusy = false;
        if (dataMessages.success.length === items.length) {
          makeToastSuccess('Cập nhật trạng thái sản phẩm thành công');
          this.resetModal();
          this.$emit('refresh', true);
        } else {
          if (this.isCancelled) {
            this.fileName = '';
            this.isCancelled = false;
            return;
          }
          makeToastFaile('Một số sản phẩm cập nhật thất bại');
        }
      }
    },

    resetModal() {
      this.items = [];
      this.fileName = '';
      this.statusParent = null;
      this.currentPage = 1;
      this.isCancelled = false;
      this.$bvModal.hide('md-change-status-product-excel');
    },

    popupProductCommon() {
      this.$bvModal.show('md-change-status-product-excel');
      this.statusParent = null;
    },

    getDataFromExcel(data, fileName) {
      if (this.isBusy) {
        return makeToastFaile('Không thể tải file khi đang cập nhật!');
      }
      this.fileName = fileName;
      const productIds = data.rows.reduce((acc, item) => {
        if (item.isValid) {
          acc.push(item.productId || item.productCode);
        }
        return acc;
      }, []);
      const productIdsError = data.rows.filter((item) => !item.isValid);

      ApiService.post(`/product/status/ids`, {
        productIds,
      })
        .then((response) => {
          const { data } = response.data;
          const { status, message } = response.data;

          if (status) {
            setTimeout(() => {
              this.items = data.map((item) => ({
                ...item,
                statusName: PRODUCT_STATUS_NAME[item.status] || '',
                toStatus: null,
                toStatusName: null,
                statusValidate: null,
                statusValidateName: '',
                onLoading: false,
              }));
              productIdsError.forEach((product) => {
                this.items.push({
                  id: product.productId || product.productCode,
                  productName: null,
                  status: null,
                  statusName: null,
                  toStatus: null,
                  toStatusName: null,
                  statusValidate: STATUS_VALIDATE.INVALID,
                  statusValidateName: product.errors.join(', '),
                  onLoading: false,
                });
              });
              this.onLoadingList = false;
              this.isCancelled = false;
            }, TIME_TRIGGER);
          } else {
            makeToastFaile(message);
            this.onLoadingList = false;
            this.isCancelled = false;
          }
        })
        .catch((err) => {
          if (!err.response) {
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.onLoadingList = false;
          this.$nprogress.done();
        });
    },

    clearFileExcel() {
      if (this.isBusy) {
        return makeToastFaile('Không thể xóa file khi đang cập nhật!');
      }
      this.items = [];
      this.fileName = '';
      this.isCancelled = false;
    },
  },
};
</script>

<style scoped>
.table-common /deep/ .vue-treeselect__input-container {
  padding-top: 0px;
}

.table-common /deep/ .vue-treeselect__control {
  border-radius: none;
  border: none;
  height: 2.5rem;
}

.table-common /deep/ .vue-treeselect__input {
  font-size: 22px;
}
</style>

